<template>
  <div class="para" style="width: 100%; margin-top: 0">
    <!-- ******************************************************************
                 *  事業者アカウント情報                                          *
                 ****************************************************************** -->
    <div class="para" style="margin-top: 0">
      <p class="lead" style="margin-top: 0">アカウント情報を編集します。</p>
      <h2 class="h3">利用者情報</h2>
      <div class="criteria">
        <div class="frm-row">
          <span class="frm-label w-150px">
            <strong>権限種別</strong>
          </span>
          <span
            class="frm-label w-150px"
            v-if="accountDataForm.userAuthorityType === 1"
          >
            <label> 管理者 </label>
          </span>
          <ToggleButton
            v-model="accountDataForm.userAuthorityType"
            :list="radioList"
            ref="userAuthorityTypeToggle"
            tabindex="1"
            v-else-if="
              accountDataForm.userAuthorityType === 2 ||
              accountDataForm.userAuthorityType === 3
            "
          />
        </div>

        <div class="frm-row" :class="!isTatsuzinIdError ? 'mt-5' : ''">
          <span class="frm-label w-150px">
            <strong>ログインID</strong>
          </span>
          <input
            type="text"
            ref="refTatsuzinId"
            class="frm-text frm-size-l"
            v-model="accountDataForm.tatsuzinId"
            maxlength="50"
            tabindex="2"
            :class="{ error: isTatsuzinIdError }"
          />
        </div>
        <p class="errMsg" style="margin-left: 160px" v-show="isTatsuzinIdError">
          <ErrorMessageCase :errors="errors_tatsuzinId"></ErrorMessageCase>
        </p>
        <div class="frm-row" :class="!isUserNameError ? 'mt-5' : ''">
          <span class="frm-label w-150px">
            <strong>利用者名</strong>
          </span>
          <input
            type="text"
            class="frm-text frm-size-l"
            v-model="accountDataForm.userName"
            maxlength="50"
            tabindex="3"
            :class="{ error: isUserNameError }"
            id="name"
            @input="nameInputChange"
          />
        </div>
        <p class="errMsg" style="margin-left: 160px" v-show="isUserNameError">
          <ErrorMessageCase :errors="errors_userName"></ErrorMessageCase>
        </p>
        <div class="frm-row" :class="!isUserNameFError ? 'mt-5' : ''">
          <span class="frm-label w-150px">
            <strong>フリガナ</strong>
          </span>
          <input
            type="text"
            class="frm-text frm-size-xl"
            v-model="accountDataForm.userNameF"
            maxlength="50"
            tabindex="4"
            :class="{ error: isUserNameFError }"
            id="kana"
          />
        </div>
        <p class="errMsg" style="margin-left: 160px" v-show="isUserNameFError">
          <ErrorMessageCase :errors="errors_userNameF"></ErrorMessageCase>
        </p>
        <div class="frm-row" :class="!isEMailAddressError ? 'mt-5' : ''">
          <span class="frm-label w-150px">
            <strong>メールアドレス</strong>
          </span>
          <input
            type="text"
            class="frm-text frm-size-xl"
            v-model="accountDataForm.eMailAddress"
            maxlength="255"
            tabindex="5"
            :class="{ error: isEMailAddressError }"
          />
        </div>
        <p
          class="errMsg"
          style="margin-left: 160px"
          v-show="isEMailAddressError"
        >
          <ErrorMessageCase :errors="errors_eMailAddress"></ErrorMessageCase>
        </p>
      </div>
    </div>
    <br />
    <!-- ******************************************************************
             *  下部ボタン群                                                  *
             ****************************************************************** -->
    <div class="frm-btn-row footer-btn">
      <div class="frm-item grow center">
        <button
          class="frm-btn strong large"
          type="button"
          @click="handleConfirm"
          :disabled="isConfirmBtnDisabled"
          tabindex="6"
        >
          確定
        </button>
        <button
          class="frm-btn large"
          type="button"
          @click="handleCancel"
          tabindex="6"
        >
        キャンセル
        </button>
      </div>
    </div>
    <ConfirmDialog
      :isShow="isRouterChangeShow"
      :message="routerChangeMessage"
      @confirm="routerChangeConfirm"
      @cancel="routerChangeCancel"
    ></ConfirmDialog>
    <PasswordChangeModal
      ref="refPasswordChangeModal"
      :isShow="isPasswordChangeShow"
      :loginId="accountDataForm.tatsuzinId"
      :initialLoginId="tatsuzinId"
      :userName="accountDataForm.userName"
      :passwordChangeRequestFlag="accountDataForm.passwordChangeRequest"
      :parentPageId="pageId"
      @close="isPasswordChangeShow = false"
      @detailChangeConfirm="updateAccountDetail"
    ></PasswordChangeModal>
    <ConfirmDialog
      :isShow="isIdChangeShow"
      :message="idChangeMessage"
      @confirm="idChangeConfirm"
      @cancel="idChangeCancel"
      width="630"
    ></ConfirmDialog>
  </div>
</template>

<script setup>
// #region import
import { ref, reactive, computed, onMounted, watch, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import router from "../../../router";
import Common from "@/util/common.js";
import ToggleButton from "@/components/ToggleButton.vue";
import PasswordChangeModal from "@/components/STDSDC05C04PasswordChange.vue";
import {
  API_DisplayAccount,
  API_UpdateAccount,
} from "@/api/Modules/DC05/STDSDC05C03";
import Validation from "@/util/validation.js";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import { onlyFullWidth } from "@/util/Kuroshiro";
//#endregion

// #region 初期表示
// 親画面エラー表示制御
const { commit } = useStore();
const isConfirmBtnDisabled = ref(false);
const isPasswordChangeShow = ref(false);
const pageId = ref("STDSDC05C03");
const tatsuzinId = $cookies.get("STDSDC05C03TatsuzinId");
const userKeyName = $cookies.get("STDSDC05C03UserKeyName");
const userAuthorityTypeToggle = ref(null);
const refTatsuzinId = ref(null);
const refPasswordChangeModal = ref(null);
const currentLoginId = $cookies.get("currentLoginId");

const accountDataForm = reactive({
  userKeyName: "",
  userAuthorityType: "",
  tatsuzinId: "",
  userName: "",
  userNameF: "",
  eMailAddress: "",
  keyName: "",
  keyNameType: "",
  password: null,
  passwordChangeRequest: false,
});

//　権限種別 list
const radioList = [
  { code: 2, text: "管理ユーザー" },
  { code: 3, text: "一般ユーザー" },
];
const nameInputChange = async () => {
  accountDataForm.userNameF = "";
  accountDataForm.userNameF = (await onlyFullWidth(accountDataForm.userName)).substring(0,50);
};
// const userAuthorityTypeName = ref("");
// 初期データ
const getData = () => {
  let params = {
    userInfoDetail: {
      keyName: userKeyName,
    },
  };
  API_DisplayAccount(params).then((response) => {

    if (response.result == "0000") {
      accountDataForm.keyName = response.userInfoDetail.keyName;
      accountDataForm.tatsuzinId = response.userInfoDetail.tatsuzinId;
      accountDataForm.userName = response.userInfoDetail.userName;
      accountDataForm.userNameF = response.userInfoDetail.userNameF;
      accountDataForm.eMailAddress = response.userInfoDetail.eMailAddress;
      accountDataForm.userAuthorityType =
        response.userInfoDetail.userAuthorityType;
      accountDataForm.keyName = response.userInfoDetail.keyName;
      accountDataForm.keyNameType = response.userInfoDetail.keyNameType;
      accountDataForm.passwordChangeRequest =
        response.userInfoDetail.passwordChangeRequest;
    } else {
      let topError = [];
      if (response.errorCD === "MTCL1126") {
        topError = [
          Common.createError(
            "MTCL1126",
            Common.getMessage("MTCL1126", ["編集"])
          ),
        ];
      } else {
        topError = [
          Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          ),
        ];
      }

      commit("securityModule/updateErrors", topError);
      // エラー表示
    }
    })
    .finally(() => {
      nextTick(() => {
        initFocus();
      });
  });
};
const initFocus = () => {
  // 初期位置設定
  nextTick(() => {
    if (userAuthorityTypeToggle.value) {
      userAuthorityTypeToggle.value.focus();
    } else if (refTatsuzinId.value) {
      refTatsuzinId.value.focus();
    }
  });
};
onMounted(() => {
  // 初期位置設定
  nextTick(() => {
    if (userAuthorityTypeToggle.value) {
      userAuthorityTypeToggle.value.focus();
    } else if (refTatsuzinId.value) {
      refTatsuzinId.value.focus();
    }
  });

  getData();
});

//#endregion

// #region 「確定」ボタン押下処理
const handleConfirm = () => {
  if (validateForm()) {
    if (
      currentLoginId === tatsuzinId &&
      accountDataForm.tatsuzinId !== tatsuzinId
    ) {
      isPasswordChangeShow.value = true;
    } else if (
      currentLoginId !== tatsuzinId &&
      accountDataForm.tatsuzinId !== tatsuzinId
    ) {
      isIdChangeShow.value = true;
    } else {
      const param = {
        userInfoDetail: accountDataForm,
      };
      API_UpdateAccount(param).then(async (response) => {
        if (response.result == "0000") {
          toRouter.value = {
            name: "STDSDC05C02",
          };
          router.push(toRouter.value);
        } else {
          // エラー表示
          const topError = response.errorName
            ? [
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [response.errorName[0]])
                ),
              ]
            : [
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                ),
              ];
          commit("securityModule/updateErrors", topError);
        }
      });
    }
  }
};

// 「キャンセル」ボタン押下処理
const handleCancel = () => {
  toRouter.value = {
    name: "STDSDC05C02",
  };

  isRouterChangeShow.value = true;
};

// パスワード変更した後詳細情報更新
const updateAccountDetail = (passwordData) => {
  accountDataForm.password = passwordData.password;
  accountDataForm.passwordChangeRequest =
    passwordData.passwordChangeRequestFlag;
  const param = {
    userInfoDetail: accountDataForm,
    oldPassword: passwordData.oldPassword,
    oldTatsuzinId: tatsuzinId,
  };
  API_UpdateAccount(param).then(async (response) => {
    if (response.result == "0000") {
      toRouter.value = {
        name: "STDSDC05C02",
      };
      isPasswordChangeShow.value = false;
      router.push(toRouter.value);
    } else {
      // エラー表示
      const msg = response.errorName
        ? Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [response.errorName[0]])
          )
        : Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          );
      refPasswordChangeModal.value.addErrors(msg);
    }
  });
};
//#endregion

// #region 画面遷移確認
const toRouter = ref(null);
const isRouterChangeShow = ref(false);
const routerChangeMessage = ref(Common.getMessage("MTCL2001", []));

// 画面遷移確認ダイアログ「ok」ボタン押下
const routerChangeConfirm = () => {
  isRouterChangeShow.value = false;
  router.push(toRouter.value);
};

// 画面遷移確認ダイアログ「キャンセル」ボタン押下
const routerChangeCancel = () => {
  toRouter.value = null;
  isRouterChangeShow.value = false;
};

onBeforeRouteLeave((to, from, next) => {
  if (
    !$cookies.get("SessionID") ||
    to.name == "STDSCM04C06" ||
    toRouter.value
  ) {
    next();
  } else {
    toRouter.value = to;
    isRouterChangeShow.value = true;
  }
});
//#endregion

// #region エラー表示制御

const errors_tatsuzinId = ref([]);
const errors_userName = ref([]);
const errors_userNameF = ref([]);
const errors_eMailAddress = ref([]);

const isTatsuzinIdError = computed(() => {
  return errors_tatsuzinId.value.length > 0;
});

const isUserNameError = computed(() => {
  return errors_userName.value.length > 0;
});

const isUserNameFError = computed(() => {
  return errors_userNameF.value.length > 0;
});

const isEMailAddressError = computed(() => {
  return errors_eMailAddress.value.length > 0;
});

const validateForm = () => {
  errors_tatsuzinId.value = [];
  errors_userName.value = [];
  errors_userNameF.value = [];
  errors_eMailAddress.value = [];

  // ログインID
  // 必須チェック
  if (!accountDataForm.tatsuzinId) {
    errors_tatsuzinId.value.push(
      Common.createError(
        "MTCL1001",
        Common.getMessage("MTCL1001", ["ログインID"])
      )
    );
  } else if (checkIdChar(accountDataForm.tatsuzinId)) {
    // 半角チェック
    errors_tatsuzinId.value.push(
      Common.createError(
        "MTCL1004",
        Common.getMessage("MTCL1004", ["ログインID"])
      )
    );
  }
  // 利用者名(フリガナ)
  // 必須チェック
  if (!accountDataForm.userNameF) {
    errors_userNameF.value.push(
      Common.createError(
        "MTCL1001",
        Common.getMessage("MTCL1001", ["フリガナ"])
      )
    );
  } else if (checkNameChar(accountDataForm.userNameF)) {
    // 文字列内に入力禁止文字が含まれていないこと
    errors_userNameF.value.push(
      Common.createError(
        "MTCL1098",
        Common.getMessage("MTCL1098", ["フリガナ"])
      )
    );
  }

  // 利用者名
  // 必須チェック
  if (!accountDataForm.userName) {
    errors_userName.value.push(
      Common.createError(
        "MTCL1001",
        Common.getMessage("MTCL1001", ["利用者名"])
      )
    );
  } else if (checkNameChar(accountDataForm.userName)) {
    // 文字列内に入力禁止文字が含まれていないこと
    errors_userName.value.push(
      Common.createError(
        "MTCL1098",
        Common.getMessage("MTCL1098", ["利用者名"])
      )
    );
  }

  // メールアドレス形式チェック
  if (
    accountDataForm.eMailAddress &&
    !Validation.isMail(accountDataForm.eMailAddress)
  ) {
    errors_eMailAddress.value.push(
      Common.createError(
        "MTCL1015",
        Common.getMessage("MTCL1015", ["メールアドレス"])
      )
    );
  }

  if (
    isTatsuzinIdError.value ||
    isUserNameError.value ||
    isUserNameFError.value ||
    isEMailAddressError.value
  ) {
    return false;
  }
  return true;
};

watch(
  [isTatsuzinIdError, isUserNameError, isUserNameFError, isEMailAddressError],
  (newVal) => {
    const topError =
      newVal.filter((item) => item).length > 0
        ? [Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))]
        : [];
    commit("securityModule/updateErrors", topError);
  }
);

// #endregion

// ログインIDの許容文字
const checkIdChar = (str) => {
  // let containSpecial = RegExp(/^[0-9a-zA-Z(\-)(\_)(\.)]+$/);
  let containSpecial = RegExp(/[^\w-.]/);
  return containSpecial.test(str);
};

// 利用者名、フリガナの禁則文字チェック
const checkNameChar = (str) => {
  // let containSpecial = RegExp(/[(\")(\')(\<)(\>)(\\)(\;)(\&)]+/);
  let containSpecial = RegExp(/["'<>\\;&]/);
  return containSpecial.test(str);
};

//#region idChangeConfirm
const isIdChangeShow = ref(false);
const idChangeMessage = ref(Common.getMessage("MTCL2097", []));

// 画面遷移確認ダイアログ「ok」ボタン押下
const idChangeConfirm = () => {
  isIdChangeShow.value = false;
  isPasswordChangeShow.value = true;
};

// 画面遷移確認ダイアログ「キャンセル」ボタン押下
const idChangeCancel = () => {
  isIdChangeShow.value = false;
};

// #endregion
</script>
